import React from 'react';
import logoSVG from '../../assets/brand/End_of_an_Era_Logo.svg';
import mfaPNG from '../../assets/brand/end-of-era-text_2025-06-15T16-33-35.png'; 

interface BrandSymbolProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '3xl' | '4xl' | 'responsive';
  className?: string;
  showText?: boolean;
  showTagline?: boolean; 
  variant?: 'light' | 'dark';
}

const BrandSymbol: React.FC<BrandSymbolProps> = ({ 
  size = 'md', 
  className = '',
  showText = false,
  showTagline = false, 
  variant = 'light'
}) => {
  const sizeClasses = {
    sm: 'w-6 h-4',
    md: 'w-8 h-6',
    lg: 'w-12 h-8',
    xl: 'w-16 h-12',
    '3xl': 'w-48 h-32',
    '4xl': 'w-64 h-40', 
    responsive: 'w-24 h-16 sm:w-32 sm:h-20 lg:w-40 lg:h-24 xl:w-48 xl:h-32'
  };

  const logoSrc = showTagline ? mfaPNG : logoSVG;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showText ? (
        <img
          src={logoSrc}
          alt="End of an Era logo"
          className={`${sizeClasses[size]} object-contain ${
            variant === 'light' && !showTagline ? 'brightness-0 invert' : ''
          }`}
        />
      ) : (
        <svg 
          className={sizeClasses[size]} 
          viewBox="0 0 120 80" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
        {/* Left circle - Teal */}
          <circle cx="35" cy="40" r="25" fill="#0D9488" opacity="0.9" />
        
        {/* Right circle - Light Blue */}
          <circle cx="85" cy="40" r="25" fill="#67E8F9" opacity="0.8" />
        
        {/* Center overlap - Green */}
          <ellipse cx="60" cy="40" rx="15" ry="20" fill="#84CC16" opacity="0.7" />
        
        {/* Inner white highlights for depth */}
          <circle cx="30" cy="35" r="8" fill="white" opacity="0.3" />
          <circle cx="90" cy="35" r="8" fill="white" opacity="0.3" />
        </svg>
      )}
    </div>
  );
};

export default BrandSymbol;
export { BrandSymbol };